<template>
  <div>
    <div style="display: flex;" class="daYinPageTop">
      <el-page-header @back="back" style="margin-right:20px;"></el-page-header>
      <button type="primary" @click="printContext">打印</button>
    </div>
    <div id="printMe" ref="print">
      <div class="table_title">唐山曹妃甸兴翰钢铁物流有限责任公司装车单</div>
      <div class="AMarkUl">
        <ul>
          <li style="width:43%;">客户名称: {{ATableData.customerName}}</li>
          <li style="width:22%;">装车日期: {{dateFormat1(new Date(),'')}}</li>
          <li style="width:20%;">车牌号码: {{ATableData.plateNumber }}</li>
          <li style="width:15%;">司机姓名: {{ATableData.driverName}}</li>
        </ul>
      </div>
      <table>
        <tbody>
          <tr>
            <td>捆包号</td>
            <td>品名</td>
            <td>材质</td>
            <td>规格</td>
            <td>重量(吨)</td>
            <td>货位</td>
          </tr>
          <tr v-for="(item,index) in ATableList" :key="index">
            <td>{{item.cargoBarcode}}</td>
            <td>{{item.productName}}</td>
            <td>{{item.material}}</td>
            <td>{{item.specification}}</td>
            <td>{{item.weight}}</td>
            <td>{{item.locationName}}</td>
          </tr>
        </tbody>
      </table>

      <div class="AMarkFoot">
        <ul>
          <li style="width:30%;">打印时间:{{this.time| formatDate}}</li>
          <li style="width:25%;">共计:{{ATableData.wtotall}}(吨)&nbsp;&nbsp;&nbsp;{{ATableData.size}}(件)</li>
          <li style="width:20%;">制单人:{{ATableData.name}}</li>
          <li style="width:20%;">打印人:{{daYinName}}</li>
        </ul>
      </div>
      <hr>
      <article class="gaozhishu">
        <h2 style="text-align:center;">外部单位车辆及人员安全告知书</h2>
        <p>一、外部单位车辆及人员(以下简称乙方)进入唐山曹妃甸兴瀚物流有限公司(以下简称甲方)从事各项工作，应当严格遵守甲方的各项管理规定，并接受甲方监督。</p>

        <p>二、乙方接受甲方安全管理的内容包括生产安全、人身安全、设备安全、交通安全、环境保护、治安、消防等方面。</p>
        <p>三、乙方需遵循规定如下:</p>
        <p>1、乙方作业人员严禁未经许可进入作业现场，需进入作业现场的，乙方作业人员进入作业区域需佩戴好安全帽及各项劳动保护用品。在得到甲方现场作业人员许可后，方可进入。</p>
        <p>3、现场作业人员（乙方）应时刻注意周围环境，乙方参与辅助装卸人员必须服从甲方现场作业人员的指挥，当吊物距车辆作业面小于等于50cm时，乙方辅助作业人员必须选择有回旋余地的安全方位协助作业，严禁乙方协助作业人员在吊物下或吊物的运动方向停侯。确定吊装货物周围安全后方可进行（辅助）作业。</p>
        <p>4、进入甲方大门及转弯、过磅进入装卸作业区域时乙方机动车辆行驶速度不得超过5公里／时；在保证安全的情况下，在甲方厂内道路行驶时不得超过25公里／时，禁止超速、强行、超车、加塞等。</p>
        <p>5、以上内容阅读完在安全告知台账上签字确认、乙方违任意一条甲方有权对乙方进行考核。</p>
        <div style="margin-top:20px;font-weight:600;">
          <span>司机签名：</span>
          <span style="float:right;margin-right:100px;">司机手机号: {{ATableData.driverMobile}}</span><br>
          <span style="float:right;margin-right:100px;font-size:28px">装车电话:13303251823</span>
        </div>
        <div style="font-weight:600;margin-left:80px;margin-top:10px;">确认已知悉。</div>
        <div style="font-weight:600;margin-top:10px;">天车工签字：</div>
        <div style="text-align:right;margin-right:70px;margin-top:20px;">
          <span>时间: {{dateFormat1(new Date(),'CHN')}}</span>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import {
  printOutstockDocument // 主数据-打印
} from '@/api/wms-access'
import DonMessage from '@/utils/message'
import { dateFormat1 } from '@/utils/util'

export default {
  data () {
    return {
      dateFormat1: dateFormat1,
      id: '',
      name: '',
      DYname: '',
      time: Date.parse(new Date()),
      daYinName: '',
      getData: null,
      getFlag: false,
      ATableList: [], // 表格
      ATableData: [] // 信息
    }
  },
  created () {
    // 生命周期里接收参数
    this.id = this.$route.query.id // 接受参数关键代码
    this.DYname = this.$route.query.DYname
    this.daYinName = this.userName = localStorage.getItem('userName')
    this.name = localStorage.getItem('tenantName')
  },
  mounted () {
    this.printOutstockDocumentS()
  },
  methods: {

    // 打印内容
    printContext () {
      this.$print(this.$refs.print)
    },
    // 点击返回上一步
    back () {
      this.$router.go(-1) // 返回上一层
    },
    // 出库计划-主数据-打印
    printOutstockDocumentS () {
      printOutstockDocument({
        outstockId: this.id // 出库主表id
      })
        .then(res => {
          // printOutStockList-数据
          // data-->信息
          this.ATableList = res.printOutStockList
          this.ATableData = res.parameters
          if (this.ATableData.news !== '') {
            this.getFlag = true
          } else {
            this.getFlag = false
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    }

  },
  filters: {
    formatDate: function (value) {
      if (value == null) {
        return ''
      }
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  }
}
</script>
<style scoped lang='less'>
button {
  width: 100px !important;
}
#printMe {
  position: relative;
  padding-top: 50px;
  padding: 50px 30px 0;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  border: 1px solid #ccc;

  .table_title {
    width: 100%;
    height: 40px;
    font-size: 25px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
.AMarkUl {
  font-size: 14px;

  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 0 !important;
    padding: 0 !important;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
.AMarkFootT {
  font-size: 14px;

  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 0 !important;
    padding: 0 !important;
    li {
      list-style: none;
      flex: 1;
      // color: black;
    }
  }
}
.AMarkFoot {
  font-size: 14px;

  width: 100%;
  ul {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
table,
th,
td {
  border: 1px solid blue;
}
table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 2px solid black;
}
table {
  font-size: 14px;

  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  margin-top: 10px;
  td {
    width: 10%;
    text-align: center;
    height: 28px;
  }
}
/* BEGIN打印不显示页眉BEGIN */
@page {
  size: auto; /* auto is the initial value */
  margin: 3mm; /* this affects the margin in the printer settings */
}

html {
  background-color: #ffffff;
  margin: 0px; /* this affects the margin on the html before sending to printer */
}

body {
  border: solid 1px blue;
  margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
}
hr {
  width: 100%;
  height: 4px;
  border: none;
  border-top: dashed 4px #dcdfe6;
}
.gaozhishu {
  margin-top: 20px;
  h4 {
    margin: 0;
  }
  p {
    margin: 5px;
    letter-spacing: 2px;
    padding: 0;
  }
}
/* END打印不显示页眉END */
</style>
